import { render, staticRenderFns } from "./ViewPlan.vue?vue&type=template&id=160b1279"
import script from "./ViewPlan.vue?vue&type=script&lang=js"
export * from "./ViewPlan.vue?vue&type=script&lang=js"
import style0 from "./ViewPlan.vue?vue&type=style&index=0&id=160b1279&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports